import './styled.scss';
import { useState, useRef, useEffect } from 'react';
import { listContent, listContentFile } from 'data/household';
import { GetMobileStyledCompImg } from 'common-modules/general/Modules/functions';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLocation } from 'react-router';

SwiperCore.use([Navigation]);

const HouseHold = () => {
  const [toggleState, setToggleState] = useState(1);
  const [checked, setChecked] = useState(false);

  const [listCnt, setListCnt] = useState(listContent[0]);

  const toggleTab = index => {
    setToggleState(index);
  };

  // 팝업 설정 관련
  const popUp = useRef<any>(null);
  const popUpImg = useRef<any>(null);
  const openPopUp = (popUpName, img?: any) => {
    popUpName.current.style.visibility = 'visible';
    popUpName.current.style.opacity = 1;
    const body = document.body;

    body.style.overflow = 'hidden';
    if (img) {
      popUpImg.current.setAttribute('src', img);
    }
  };
  const closePopUp = popUpName => {
    popUpName.current.style.visibility = 'hidden';
    popUpName.current.style.opacity = 0;
    const body = document.body;

    body.style.overflow = '';
  };

  useEffect(() => {
    setListCnt(listContent.find(val => val.id === toggleState) || listContent[0]);
  }, [toggleState]);

  const params = useLocation();
  const searchId = params.search.replace('?tabId=', '');

  useEffect(() => {
    if (searchId) {
      const changeIdData = listContent.map(item => {
        return { ...item, tit: item.tit.replace('㎡', '').replace('형', '').replace('평', '') };
      });
      const filterData = changeIdData.find(({ tit }) => tit === searchId);

      if (filterData) {
        setToggleState(filterData.id);
      }
    }
  }, [searchId]);

  // 220830 add
  interface contentList {
    name: string;
    isActive: boolean;
  }

  const contentList = [
    { name: '특징', isActive: false },
    { name: '평면정보', isActive: true }
  ];
  
  return (
    <div className="contents-household-outline-mobile">

      {/* 특징 */}
      {contentList[0].isActive ? (
        <section className="container section-tit pt-60 t-center">
          <i className="ico-double-dot"></i>
          <h3 className="title pt-25">
            공간은 여유롭게, 일상은 편안하게<br/>
            e편한세상의 섬세한 평면 설계
          </h3>
          <p style={{ color: '#666', lineHeight: 1.5 }} className="sub-title pt-10">
            'e편한세상 시티 도안’에서 생활의 차이는
            <br />
            커지고 내일의 가치는 더 커집니다.
          </p>
        </section>
      ) : null}

      {/* 평면정보 */}
      {contentList[1].isActive ? (
        <>
          <section className="section pt-75 mb-60">
            <div className="slider-2">
              <div className="container">
                <div className="swiper-wrapper">
                  {listContent.map((hContent, idx) => {
                    return (
                      <div className="swiper-slide">
                        <button
                          key={idx}
                          className={toggleState === hContent.id ? 'btn on' : 'btn'}
                          onClick={() => toggleTab(hContent.id)}>
                          {hContent.tit}
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
  
            <div className="container">
              <div className="section-content mt-55">
                <div className="right-util-area">
                  <div className="check-switch">
                    <span className="fnt15">㎡ (전용면적)</span>
                    <label htmlFor="checkbox101">
                      <input type="checkbox" id="checkbox101" defaultChecked={checked} onChange={() => setChecked(!checked)} />
                      <div className="check-box">
                        <span className="round"></span>
                      </div>
                    </label>
                    <span className="fnt15">평 (공급면적)</span>
                  </div>
                </div>
  
                <h3 className="h-title large01 pt-10">
                  <span className="h-title">{checked ? listCnt.tit2 : listCnt.tit}</span>
                </h3>
                <p style={{ lineHeight: 1.5 }} className="txt-title-02 pt-15">
                  {listCnt.subtit2}
                </p>
                <p className="txt-desc pt-15">{listCnt.subtit}</p>
              </div>
  
              {/* 이미지 */}
              <div className="list-img pt-30">
                <div className="img">
                  <img
                    onClick={() => {
                      openPopUp(popUp, `${listCnt.img2_big}`);
                    }}
                    src={listCnt.img2}
                    alt=""
                  />
                </div>
                <div className="img pt-30">
                  <img
                    onClick={() => {
                      openPopUp(popUp, `${listCnt.img1}`);
                    }}
                    src={listCnt.img1}
                    alt=""
                  />
                </div>
                <Swiper
                key={toggleState}
                pagination={false}
                preventClicks={false}
                navigation={false}
                slidesPerView={1.2}
                spaceBetween={0}
                className="offer-swiper">
                {listCnt.swiper?.map((sp, index) => {
                  return (
                    <SwiperSlide key={sp.img}>
                      <div className="slide-items-img">
                        <img
                          onClick={() => {
                            openPopUp(popUp, `${sp.img}`);
                          }}
                          src={sp.img}
                          alt=""
                        />
                      </div>
                      <div className="slide-items-content"></div>
                      <div className="slide-items-content-text">
                        {listCnt.tit}
                        <span className="sub">&nbsp;/&nbsp;{sp.title}</span>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
                {/* <div className="img pt-30">
                  <img
                    onClick={() => {
                      openPopUp(popUp, `${listCnt.img3}`);
                    }}
                    src={listCnt.img3}
                    alt=""
                  />
                </div>
                <div className="img pt-30">
                  <img
                    onClick={() => {
                      openPopUp(popUp, `${listCnt.img4}`);
                    }}
                    src={listCnt.img4}
                    alt=""
                  />
                </div> */}
              </div>
  
              {/* 추가선택품목 */}
              <div className="txt02 pt-30">추가선택품목</div>
              <div className="payment-info-area mt-20">
                <div className="column-group">
                  <div className="normal">
                    <div className="column">
                      <span className="txt01">
                        {listCnt.addInfo.split('\n').map((i, key) => {
                          return <div key={key}>{i}</div>;
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="txt02 pt-30">상세내용</div>
              <div className="payment-info-area mt-20">
                <div className="column-group">
                  <div className="row">
                    <div className="column">
                      <span className="txt01">전용면적</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.residential_area}</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column">
                      <span className="txt01">공용면적</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.common_residential_area}</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column">
                      <span className="txt01">공급면적</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.supply_area}</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="column">
                      <span className="txt01">기타 공용면적</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.other_common_areas}</span>
                    </div>
                  </div>
                  {/* <div className="row">
                    <div className="column">
                      <span className="txt01">지하주차장</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.underground_parking_lot}</span>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="column">
                      <span className="txt01">계약면적</span>
                    </div>
                    <div className="column t-right ">
                      <span className="txt02">{listCnt.contract_area}</span>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="txt-list01 mt-30">
                <p className="desc">* 유니트 및 면적은 소비자의 이해를 돕기 위한 것으로 건축설계변경 및 그 이외의 사유로 변경될 수 있습니다.</p>
                <p className="desc pt-10">* 본 제작물에 사용된 아이소메트릭 및 평면도는 소비자의 이해를 돕기 위한 것으로 건축설계변경 또는 그 외의 사유로 인해 변경될 수 있습니다.</p>
                <p className="desc pt-10">* 일부 품목은 분양가 제외품목이오니 주택 전시관에서 반드시 확인하시기 바랍니다.</p>
                <p className="desc pt-10">* 입면 디자인을 위해 발코니 턱, 발코니 샤시 및 난간 설치는 동일 평형이라도 호수별로 다르게 설계될 수 있습니다.</p>
                <p className="desc pt-10">* 본 홍보물은 분양 승인 시 제출된 것으로 실제 시공시 변경될 수 있음을 유념하시기 바랍니다.</p>
              </div>
            </div>
          </section>
  
          {/* 마감재 리스트, 주택형별 면적 확인 버튼 추가 */}
          <div className="line-download">
          {listContentFile.map((v, key) => {
            return (
              <div className="btn-wrap" key={key}>
                <button
                  className="btn-type01"
                  onClick={e => {
                    window.open(v.file, '__blank');
                  }}>
                  {v.title}
                </button>
              </div>
            );
          })}
          </div>
        </>
      ) : null}

      <div ref={popUp} className="pop-up">
        <div className="pop-up-header">
          <img
            onClick={() => {
              closePopUp(popUp);
            }}
            className="btn-close"
            src={GetMobileStyledCompImg('common/ico_close02.png')}
            alt="icoClose02"
          />
        </div>
        <div>
          <div className="pop-up-img">
            <img ref={popUpImg} src="" alt="DL건설" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HouseHold;
